
export const MAX_4U_WIDTH = 359;
export const MAX_NARROW_WIDTH_PRINT = 114;

export const LONG = 'long';
export const SHORT = 'short';


export const REGEXP_QUARTER = /^([1-4]Q|[1-2]H)?\s*(FY)?['|\u2019]?(\d{2,4})/i;
export const REGEXP_Q_ONLY = /^([1-4]Q|[1-2]H)/i;

export const REGEXP_MDY = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\b/;
export const REGEXP_MDY_FRED = /^(\d{4})-(\d{2})-(\d{2})\b/;
export const REGEXP_MD = /^(\d{1,2})\/(\d{1,2})\b/;
export const REGEXP_MY = /^(\d{1,2})\/(\d{3,4})\b/;
export const REGEXP_Y = /^(\d{4})\b/;
export const REGEXP_TIME = /\b(\d{1,2}):(\d{1,2})(:\d{1,2})?(\s?[a|p]\.+m\.+?)?(\s[a-z]{2,3})?$/i;

export const MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
export const MONTHS_SHORT = 'JFMAMJJASOND';

export const CATEGORY = /\{category\}/g;
export const SERIES = /\{series\}/g;
export const VALUE = /\{value\}/g;
export const POINT = /\{point\}/g;
export const SYMBOL = /\{symbol\}/g;

// Because &nbsp; does not work inside SVG.
export const NBSP = '<span style="color: rgba(255,255,255,0);" class="space">.</span>';

export const APOSTROPHE = '’';

export const TRANSPARENT = 'rgba(0, 0, 0, 0)';

export const ANNOTATIONS_SPACE = 4;
export const ANNOTATIONS_SPACE_PRINT = 2;
export const ANNOTATIONS_LINEHEIGHT = 24;
export const ANNOTATIONS_LINEHEIGHT_VIDEO = 42;


// WEBPACK FOOTER //
// ./src/chart/data/constants.js